import { render, staticRenderFns } from "./CUNopolTruck.vue?vue&type=template&id=27821a3f&scoped=true&"
import script from "./CUNopolTruck.vue?vue&type=script&lang=js&"
export * from "./CUNopolTruck.vue?vue&type=script&lang=js&"
import style0 from "./CUNopolTruck.vue?vue&type=style&index=0&id=27821a3f&prod&lang=css&"
import style1 from "./CUNopolTruck.vue?vue&type=style&index=1&id=27821a3f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27821a3f",
  null
  
)

export default component.exports